import clsx from 'clsx';
import React from 'react';

import { Button, ConditionalWrapper } from '..';
import { renderParagraph } from '../../utils';
import { ButtonProps } from '../Button';

import styles from './styles';

export interface ModalProps {
  show?: boolean;
  title?: string;
  message?: string | React.ReactNode;
  buttons?: ModalButton[];
  showAtBottom?: boolean;
}

export interface ModalButton extends Pick<ButtonProps, 'type' | 'onClick' | 'size' | 'loading' | 'disabled'> {
  text: string;
  wrapper?: React.FC;
}

const Modal: React.FC<ModalProps> = (props) => {
  return (
    <>
      <div
        className={clsx([
          'modal-backdrop fade',
          { show: props.show },
          styles.modalBackdrop,
        ])}
        style={{ 
          pointerEvents: props.show ? 'auto' : 'none',
          display: props.show ? 'flex' : 'none',
        }}
      />
      <div
        className={clsx([
          'raul-modal modal fade',
          styles.modal,
          { show: props.show },
          { [styles.modalBottom]: props.showAtBottom },
        ])}
        tabIndex={-1}
        role="dialog"
        aria-hidden="true"
      >
        <div
          className={clsx([
            'modal-dialog',
            styles.modalDialog,
          ])}
          role="document"
        >
          <div
            className={clsx([
              'modal-content',
              styles.modalContent,
            ])}
            style={{ 
              pointerEvents: props.show ? 'auto' : 'none',
              display: props.show ? 'flex' : 'none',
            }}
          >
            {props.title && (
              <div className="modal-header">
                <h5 className="modal-title">{props.title}</h5>
              </div>
            )}
            {props.message && (
              <div
                className={clsx([
                  'modal-body',
                  styles.modalBody,
                  { [styles.modalBodyGap]: props.buttons && props.buttons.length > 0 },
                ])}
              >
                {typeof props.message === 'string' ? renderParagraph(props.message) : props.message}
              </div>
            )}
            {props.buttons && props.buttons.length > 0 && (
              <div
                className={clsx([
                  'modal-footer',
                  styles.modalFooter,
                ])}
              >
                <div className={styles.modalButtonContainer}>
                  {props.buttons.map((button, i) => {
                    return (
                      <ConditionalWrapper
                        key={i}
                        condition={!!button.wrapper}
                        WrapperComponent={button.wrapper}
                      >
                        <Button
                          key={i}
                          type={button.type}
                          onClick={button.onClick}
                          size={button.size || 'normal'}
                          loading={button.loading}
                          className={clsx([
                            'button button-primary',
                            { 'button-outline': button.type === 'outline' },
                            styles.modalButton,
                          ])}
                          disabled={button.disabled}
                        >
                          {button.text}
                        </Button>
                      </ConditionalWrapper>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Modal;
